module.exports = __webpack_public_path__ + "img/quitable.1f2d40cd.png";